import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Form from './FormDisplay';
import moment, { isDate } from 'moment';
import styles from './ChangedFields.module.scss';

const ChangedFields = ({ changedFields, originalData, data, isAdd, other, fields }) => {
	const renderText = useCallback(
		(field, val) => {
			if (val !== null) {
				if (field.base != null) {
					if (typeof field.base === 'function') {
						val -= field.base(isAdd);
					} else {
						val -= field.base;
					}
				}

				if (field.options && !field.useItem) {
					if (typeof field.options === 'function') {
						return field.options(isAdd)[val];
					} else {
						if (typeof val === 'boolean') {
							val = val ? 1 : 0;
						}

						return field.options[val];
					}
				} else if (isDate(val)) {
					return moment(val).format('L');
				} else if (val instanceof moment) {
					return val.format('L');
				} else {
					if (val === true) {
						return 'Yes';
					}
					if (val === false) {
						return 'No';
					} else {
						return val;
					}
				}
			} else {
				return '';
			}
		},
		[isAdd]
	);

	return (
		<Form>
			{other &&
				other.map((o, i) => {
					return <Form.Display key={i} inline label={o.label} value={o.text} />;
				})}

			{changedFields &&
				changedFields.length > 0 &&
				Object.keys(fields).map((fieldName, i) => {
					if (!changedFields.find((c) => c === fieldName)) {
						return null;
					}

					var field = fields[fieldName];
					const newValue = renderText(field, data[fieldName]);
					const originalValue = originalData ? renderText(field, originalData[fieldName]) : null;
					return <Form.Display key={i} inline label={field.label} value={originalValue ? `${originalValue} -> ${newValue}` : `${newValue}`} width={4} />;
				})}

			{changedFields && changedFields.length === 0 && <div className={styles.noChange}>No changed information</div>}
		</Form>
	);
};

ChangedFields.propTypes = {
	data: PropTypes.array,
};

export default ChangedFields;
